export const STORAGE_KEY = 'supportflx_jwt_access_token';
